module.exports = __webpack_public_path__ + "img/step5-mobile-fr@2x.230be174.webp";